'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import SvgRefresh from '@common/icon/SvgRefresh';
import { cn } from '@core/utils';
import { useTransition } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { GoodsSectionHeader } from '../GoodsSectionHeader';
import { GOODS_SECTION_BODY_CLASS_NAME, GOODS_SECTION_TITLE, GoodsEventBanner } from './GoodsSection';
type GoodsSectionErrorProps = Pick<FallbackProps, 'resetErrorBoundary'> & {
  className?: string;
};
export const GoodsSectionError = t0 => {
  const $ = _c(15);
  const {
    resetErrorBoundary,
    className
  } = t0;
  const router = useCustomRouter();
  const [isRetrying, startRetry] = useTransition();
  let t1;
  if ($[0] !== resetErrorBoundary || $[1] !== router) {
    t1 = () => {
      startRetry(() => {
        router.refresh();
        resetErrorBoundary();
      });
    };
    $[0] = resetErrorBoundary;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleRetry = t1;
  let t2;
  if ($[3] !== className) {
    t2 = cn("flex w-full flex-col gap-24 mobile-tablet:gap-16", className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <GoodsSectionHeader eyebrow={"\uC6F0\uB85C \uC5F0\uB9D0\uD55C\uC815 \uAD7F\uC988"} title={GOODS_SECTION_TITLE} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <GoodsEventBanner />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="font-500 text-Gray-700 typo-body3 mobile-tablet:typo-body4">잠시 후 다시 시도해 주세요</p>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SvgRefresh className="size-16" />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== handleRetry || $[10] !== isRetrying) {
    t7 = <div className={GOODS_SECTION_BODY_CLASS_NAME}>{t4}<div role="alert" className="flex flex-col items-center gap-16 rounded-small bg-Gray-50 px-16 py-40">{t5}<Button theme="sub-line" dimensions="H40" loading={isRetrying} onClick={handleRetry} className="px-16">{t6}다시 불러오기</Button></div></div>;
    $[9] = handleRetry;
    $[10] = isRetrying;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t2 || $[13] !== t7) {
    t8 = <section className={t2}>{t3}{t7}</section>;
    $[12] = t2;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};